function Strike({ height = 41, width = 40 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 20" fill="none">
      <path
        d="M11.9494 5.98241C11.9494 5.98241 12.235 8.16525 10.4652 8.95576C10.4652 8.95576 12.2044 3.79447 6.76766 0C6.76766 0 8.25689 2.34094 4.54912 6.28841C0.88216 10.19 2.35098 13.403 2.35098 13.403C2.35098 13.403 1.07086 13.2755 0.504753 10.6235C0.504753 10.6235 0.106945 12.179 0.321149 14.1987C1.10656 21.4663 11.8117 22.0987 13.5457 14.9994L13.5916 14.8005C13.5916 14.7954 14.479 9.61877 11.9494 5.98241Z"
        fill="#FF4823"
      />
      <path
        d="M9.58896 12.6683C9.58896 12.6683 9.73687 13.8108 8.81375 14.2239C8.81375 14.2239 9.72156 11.5259 6.88081 9.54199C6.88081 9.54199 7.65603 10.766 5.71799 12.8265C3.80036 14.8665 4.57047 16.5495 4.57047 16.5495C4.57047 16.5495 3.90236 16.4832 3.60656 15.096C3.60656 15.096 3.39745 15.9069 3.50965 16.9626C3.92276 20.7622 9.51756 21.0937 10.4254 17.3808C10.4356 17.3451 10.4407 17.3094 10.4509 17.2737C10.4458 17.2788 10.9099 14.5707 9.58896 12.6683Z"
        fill="#FEC200"
      />
      <path
        opacity="0.3"
        d="M10.4632 8.95576C10.4632 8.95576 12.2023 3.79447 6.76562 0C6.76562 0 7.24503 0.754814 6.97983 2.13694C10.0552 5.02869 9.06067 8.32845 9.01476 8.46615C8.82096 9.04246 8.98416 9.67997 9.43297 10.088C9.88178 10.496 10.5295 10.6031 11.0854 10.3532C11.4067 10.2104 11.6872 10.0421 11.932 9.84827C12.4165 12.0872 12.136 14.1987 12.0901 14.4996L12.0595 14.6373C11.8759 15.4023 12.3043 16.1622 13.0234 16.4274C13.2376 15.9888 13.4212 15.5145 13.5487 14.9994L13.5946 14.8005C13.5946 14.8005 14.4821 9.62387 11.9524 5.98751C11.9473 5.98241 12.2329 8.16525 10.4632 8.95576Z"
        fill="white"
      />
    </svg>
  );
}

export default Strike;
